// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"3af1cc69","454":"9137da79","488":"d7a9df46","943":"92e73f02"}[chunkId] + ".chunk.js";
};